const getRelativePosition = (el1, el2) => {
  const dimension1 = el1.getBoundingClientRect();
  const dimension2 = el2 && el2.getBoundingClientRect();
  console.log(dimension1, dimension2);
  console.log(el1);
  return {
    x: dimension1.x - (100 - dimension1.width) / 2,
    y: dimension1.top - 55 - 2
  };
};

export default getRelativePosition;
